import type { Options as CustomerioOptions } from '@customerio/cdp-analytics-browser'
import type {
  AnalyticsBrowser as SegmentAnalyticsBrowser,
  Options as SegmentOptions,
  User,
} from '@segment/analytics-next'
import type { IdentifyParams, PageParams } from '@segment/analytics-next/dist/types/core/arguments-resolver'

export type AnalyticsOptions = SegmentOptions & CustomerioOptions

export type AnalyticsClient = {
  track: (eventName: string, eventData?: Record<string, unknown>, options?: AnalyticsOptions) => unknown
  identify: (...args: IdentifyParams) => unknown
  page: (...args: PageParams) => unknown
  reset: () => unknown
  trackLink?: (
    element: HTMLAnchorElement,
    eventName: string,
    eventData?: Record<string, unknown>,
    options?: AnalyticsOptions,
  ) => unknown
  user?: () => Promise<User>
}

export type AnalyticsClients = {
  customerio?: AnalyticsClient
  segment?: AnalyticsClient
}

declare global {
  interface Window {
    __lykaAnalytics?: AnalyticsClients
    segment?: SegmentAnalyticsBrowser
  }
}

const analyticsClients = (): AnalyticsClients | undefined => {
  if (typeof window === 'undefined') {
    return undefined
  }

  window.__lykaAnalytics ??= {}

  return window.__lykaAnalytics
}

export const getAnalyticsClients = (): AnalyticsClients => {
  return analyticsClients() ?? {}
}

export const setCustomerIOClient = (customerio: AnalyticsClient | undefined): void => {
  const clients = analyticsClients()

  if (clients) {
    clients.customerio = customerio
  }
}

export const setSegmentClient = (
  segment: AnalyticsClient | undefined,
  legacyWindowSegment?: SegmentAnalyticsBrowser,
): void => {
  const clients = analyticsClients()

  if (clients) {
    clients.segment = segment
  }

  if (typeof window !== 'undefined') {
    window.segment = legacyWindowSegment
  }
}
